class EthereumTopic {
    constructor(name, type, size=1) {
        this.name = name;
        this.type = type;
        this.size = size*64;
    }

    convertTo(x) {
        if (x === undefined || x === null) {
            return undefined;
        }
        return this.type.convertTo(x);
    }
   
    convertFrom(x) {
        if (x === undefined || x === null) {
            return undefined;
        }
        return this.type.convertFrom(x);
    }
}

export default EthereumTopic;
